export default __webpack_public_path__ + "static/media/mom+stroller-FINAL@2x.167f6c8f.png";